import {ModalComputerRoomWrite} from "./ModalComputerRoomWrite";

import {Button} from "../../shadCn/components/ui/button"

import {Dialog, DialogClose, DialogFooter, DialogTitle, DialogTrigger,} from "../../shadCn/components/ui/dialog"
import {selectComputerRoom} from "../../api/computerRoom/ComputerRoomService";
import React, {useEffect, useRef, useState} from "react";
import {addYears} from "date-fns";
import {toKSTISOString, toKSTISOStringEnd} from "../commonmethod/CommonMethod";
import SearchComponent from "../search/SearchComponent";
import TableComputerRoom from "../table/TableComputRoom";
import UtilsBox from "../Utils/UtilsBox";
import {useSelector} from "react-redux";
import {COMPUTER_ROOM_ACCESS_LIST_HEADER} from "../table/header/Headers";
import {ComputerDesktopIcon} from "@heroicons/react/24/outline";
import ComputerRoomIcon from "../../resources/icon/computerRoom_icon.png";
import ExcelIcon from "../../resources/icon/excel-export.png";
import Printer from "../../resources/icon/pirnter-bw.png";
import {downloadExcelByEntity} from "../commonmethod/excelMethod";


export function ModalComputerRoomAccess({isIconTrigger = false}) {
    const user = useSelector((state) => state.auth.user);
    const [modalOpen, setModalOpen] = useState(false);
    const isInitialRender = useRef(true);
    const [date, setDate] = useState({
        from: addYears(new Date(), -1),
        to: addYears(new Date(), 0),
    });
    const [search, setSearch] = useState({
        searchTxt: "",
        startDate: toKSTISOString(date.from),
        endDate: toKSTISOStringEnd(date.to),
    });
    const [pageable, setPageable] = useState({
        sort: "checkInAt",
        desc: true,
        size: 10,
        totalElements: 0,
        totalPages: 0,
        page: 0
    });

    // 초기값을 상수로 정의
    const getInitialDate = () => ({
        from: addYears(new Date(), -1),
        to: addYears(new Date(), 0),
    });

    const getInitialSearch = (date) => ({
        searchTxt: "",
        startDate: toKSTISOString(date.from),
        endDate: toKSTISOStringEnd(date.to),
    });

    const getInitialPageable = () => ({
        sort: "checkInAt",
        desc: true,
        size: 10,
        totalElements: 0,
        totalPages: 0,
        page: 0
    });
    const [data, setData] = useState();
    const [checked, setChecked] = useState([]);

    const option = {
        url: "/computerroom",
        width: 100
    }

    const [rewriteModalOpen, setRewriteModalOpen] = useState(false);
    const [rewriteData, setRewriteData] = useState(null);

    useEffect(() => {
        //현재 컴포넌트가 마운트 될 때 1번, 로딩되며 1번 하여 페이지에 오는 것 만으로 api 요청 총 2번 하게되는데 그걸 방지해서 api 요청을 한 번만 하도록 하기 위한 로직
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        getList()
    }, [pageable.page]);



    async function getList(customSearch, customPageable) {
        const searchParam = customSearch || search;
        const pageableParam = customPageable || pageable;

            selectComputerRoom(searchParam, pageableParam).then((response) => {
                if (response.status === 200) {
                    response.data.option = option;

                    setData(response.data);
                    setPageable((prevState) => ({
                        ...prevState,
                        totalElements: response.data.totalElements,
                        totalPages: response.data.totalPages,
                    }));
                }

            }).catch((error)=> {
        })

    }

    // 모달 열기 및 데이터 가져오기 함수 분리
    const handleOpenModalAndFetchData = () => {
        // 1. 모달을 열기
        setModalOpen(true);
        // 2. 데이터 가져오기
        getList();
    };

    // 검색조건 새로고침 핸들러
    const handleRefreshData = () => {
        const initialDate = getInitialDate();
        const initialSearch = getInitialSearch(initialDate);
        const initialPageable = getInitialPageable();

        setDate(initialDate);
        setSearch(initialSearch);
        setPageable(initialPageable);
        setData(undefined);
        setChecked([]);
        setModalOpen(false);

        setTimeout(() => {
            setModalOpen(true);
            getList(initialSearch, initialPageable);
        }, 0);
    };


    function handlePrint(printAreaId) {
        const printArea = document.getElementById(printAreaId);

        if (!printArea) {
            alert('프린트할 데이터가 없습니다.');
            return;
        }

        const table = printArea.querySelector('table');
        if (!table) {
            alert('프린트할 테이블이 없습니다.');
            return;
        }

        // 화면 전체 크기 가져오기
        const width = window.screen.availWidth;
        const height = window.screen.availHeight;

        // 전체화면 크기로 새 창 열기
        const printWindow = window.open(
            '',
            '_blank',
            `width=${width},height=${height},left=0,top=0,resizable=yes,scrollbars=yes,status=yes,toolbar=yes,menubar=yes`
        );

        const printContent = `
        <!DOCTYPE html>
        <html>
        <head>
            <title>전산실 출입 현황</title>
            <meta charset="utf-8">
            <style>
                * {
                    box-sizing: border-box;
                    margin: 0;
                    padding: 0;
                }
                
                body { 
                    font-family: 'Malgun Gothic', Arial, sans-serif; 
                    margin: 20px; 
                    font-size: 12px;
                    line-height: 1.4;
                }
                
                .print-header {
                    text-align: center;
                    margin-bottom: 30px;
                }
                
                .print-header h1 { 
                    font-size: 24px;
                    font-weight: bold;
                    margin-bottom: 10px;
                }
                
                .print-header h2 { 
                    font-size: 16px;
                    color: #666;
                    font-weight: normal;
                }
                
                table { 
                    width: 100%; 
                    border-collapse: collapse; 
                    margin-top: 20px;
                    border: 2px solid #000;
                    table-layout: fixed;
                    min-width: 1200px; /* 최소 너비 늘림 */
                }
                
                th { 
                    background-color: #f8f9fa;
                    border: 1px solid #000;
                    padding: 10px 6px; /* 패딩 늘림 */
                    font-size: 13px; /* 폰트 크기 늘림 */
                    font-weight: bold;
                    text-align: center;
                    white-space: nowrap;
                    overflow: hidden;
                }
                
                td { 
                    border: 1px solid #333;
                    padding: 8px 6px; /* 패딩 늘림 */
                    font-size: 11px; /* 폰트 크기 늘림 */
                    text-align: center;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                
                /* 더 넓은 픽셀로 조정 */
                th:nth-child(1), td:nth-child(1) { 
                    width: 80px !important; 
                    max-width: 80px !important; 
                    min-width: 80px !important; 
                } /* 소속 - 50px → 80px */
                th:nth-child(2), td:nth-child(2) { 
                    width: 80px !important; 
                    max-width: 80px !important; 
                    min-width: 80px !important; 
                } /* 직위 - 50px → 80px */
                th:nth-child(3), td:nth-child(3) { 
                    width: 100px !important; 
                    max-width: 100px !important; 
                } /* 성명 - 60px → 100px */
                th:nth-child(4), td:nth-child(4) { 
                    width: 140px !important; 
                } /* 연락처 - 100px → 140px */
                th:nth-child(5), td:nth-child(5) { 
                    width: 100px !important; 
                } /* 방문위치 - 80px → 100px */
                th:nth-child(6), td:nth-child(6) { 
                    width: 100px !important; 
                } /* 방문목적 - 80px → 100px */
                th:nth-child(7), td:nth-child(7) { 
                    width: 200px !important; 
                } /* 입실시간 - 140px → 200px */
                th:nth-child(8), td:nth-child(8) { 
                    width: 200px !important; 
                } /* 퇴실시간 - 140px → 200px */
                th:nth-child(9), td:nth-child(9) { 
                    width: 100px !important; 
                } /* 결재상태 - 70px → 100px */
                th:nth-child(10), td:nth-child(10) { 
                    width: 80px !important; 
                } /* 결재자 - 60px → 80px */
                th:nth-child(11), td:nth-child(11) { 
                    width: 150px !important; 
                } /* 결재시간 - 110px → 150px */
                
                /* 긴 텍스트 처리 */
                td {
                    word-break: break-all;
                    overflow-wrap: break-word;
                }
                
                /* 프린트 전용 스타일 */
                @media print {
                    body { 
                        margin: 10px;
                        font-size: 10px;
                    }
                    
                    .print-header h1 { font-size: 20px; }
                    .print-header h2 { font-size: 14px; }
                    
                    table { 
                        border: 1px solid #000;
                        font-size: 9px;
                    }
                    
                    th, td { 
                        font-size: 9px !important;
                        padding: 4px 3px !important;
                        border: 1px solid #000 !important;
                    }
                    
                    /* 프린트에서는 조금 작게 */
                    th:nth-child(1), td:nth-child(1) { 
                        width: 70px !important; 
                        max-width: 70px !important; 
                    }
                    th:nth-child(2), td:nth-child(2) { 
                        width: 70px !important; 
                        max-width: 70px !important; 
                    }
                    th:nth-child(7), td:nth-child(7) { 
                        width: 180px !important; 
                    }
                    th:nth-child(8), td:nth-child(8) { 
                        width: 180px !important; 
                    }
                    
                    tr { 
                        page-break-inside: avoid;
                        page-break-after: auto;
                    }
                }
                
                @page {
                    size: A4 landscape;
                    margin: 0.5cm;
                }
            </style>
        </head>
        <body>
            <div class="print-header">
                <h1>전산실 출입 현황</h1>
                <h2>${search.startDate} ~ ${search.endDate}</h2>
            </div>
            ${table.outerHTML}
            
            <div style="margin-top: 20px; font-size: 10px; color: #666;">
                출력일시: ${new Date().toLocaleString('ko-KR')}
            </div>
        </body>
        </html>
    `;

        printWindow.document.write(printContent);
        printWindow.document.close();

        setTimeout(() => {
            printWindow.focus();
            printWindow.print();
            setTimeout(() => {
                printWindow.close();
            }, 100);
        }, 500);
    }

    // 행 클릭 시 재작성 모달 열기
    const handleRowClick = (rowData) => {
        if(window.confirm("해당 출입건으로 재작성 페이지를 여시겠습니까?")){

        const initialData = {
            affiliation: rowData.affiliation,
            position: rowData.position,
            name: rowData.name,
            phoneNumber: '',
            visitLocation: rowData.visitLocation,
            visitPurpose: rowData.visitPurpose
        };

        setRewriteData(initialData);
        setRewriteModalOpen(true);
        }
        else {

        }
    };




    return (
        <Dialog>
            <DialogTrigger asChild>
                {isIconTrigger ? (
                    <button
                        type="button"
                        className="inline-flex items-center justify-center p-0 border-0 bg-transparent cursor-pointer hover:opacity-80 transition-opacity duration-200"
                        title="전산실 출입대장"
                        aria-label="전산실 출입대장"
                        onClick={handleOpenModalAndFetchData}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                             className="icon icon-tabler icons-tabler-outline icon-tabler-notebook"
                             aria-hidden="true"
                        >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                            <path
                                d="M6 4h11a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-11a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1m3 0v18"/>
                            <path d="M13 8l2 0"/>
                            <path d="M13 12l2 0"/>
                        </svg>
                    </button>
                ) : (
                    <div
                        className="flex flex-row items-center justify-start gap-[8px] cursor-pointer transition-opacity duration-200 hover:opacity-80 text-white"
                        onClick={handleOpenModalAndFetchData}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 24 24"
                             fill="none"
                             stroke="currentColor"
                             strokeWidth="2"
                             strokeLinecap="round"
                             strokeLinejoin="round"
                             className="w-[22px] h-[22px] shrink-0"
                             aria-label="전산실 출입대장 아이콘">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                            <path d="M6 4h11a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-11a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1m3 0v18"/>
                            <path d="M13 8l2 0"/>
                            <path d="M13 12l2 0"/>
                        </svg>
                        <span className="text-white font-medium text-[12px]">
                            전산실 출입대장
                        </span>
                    </div>
                )}
            </DialogTrigger>


            {modalOpen &&
                <>
                    <div className={`image-view-modal-background`} onClick={() => {
                        setModalOpen(false)
                    }}/>
                    <div
                        role="dialog"
                        data-state="open"
                        className=" h-[46rem] w-[80rem] max-w-[80rem] fixed top-[100px] left-1/2 -translate-x-1/2 z-50 grid gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg"
                        tabindex="-1" style={{
                        pointerEvents: "auto",
                        fontSize: "12px", fontWeight: "normal"
                    }}>
                        <div className="flex mt-5">

                            <ModalComputerRoomWrite Listener={getList}/>
                            <DialogTitle className="text-center flex-grow mr-[130px] text-2xl">전산실 출입 현황</DialogTitle>


                        </div>

                        <div className="">
                                <SearchComponent Listener={getList} search={{search: search, fnc: setSearch}} col={2}
                                                 setPageable={setPageable} dated={{date: date, fnc: setDate}}
                                                 invisible={{size: true, detail: true, fix: true}}
                                                 placeholder={"소속, 직위, 성명, 연락처, 방문위치, 방문목적, 결재상태"}
                                                 refresh={handleRefreshData}
                                />


                                <div className="w-[100%] h-[60px] pt-[16px] util-box align-middle">
                                    {user && <abbr title={"엑셀 다운로드"}>
                                        <button
                                            type="button"
                                            className="float-right mr-2"
                                            onClick={() => downloadExcelByEntity("ComputerRoom", search)}
                                        >
                                            <img src={ExcelIcon} className="w-[30px] h-[30px] mt-[3px] border"
                                                 alt="excel-icon"/>
                                        </button>
                                    </abbr>}

                                    <abbr title={"인쇄하기"}>
                                        <button className="float-right mr-3"
                                                onClick={() => handlePrint('computerRoomPrintArea')}>
                                            <img src={Printer} className={`w-[30px] h-[30px] mt-[5px] border`}/>
                                        </button>
                                    </abbr>

                                </div>

                                {data &&
                                    <div id="computerRoomPrintArea">
                                        <TableComputerRoom Listener={getList} header={COMPUTER_ROOM_ACCESS_LIST_HEADER}
                                                           data={data.content}
                                                           paged={{pageable: pageable, setPageable: setPageable}}
                                                           option={data.option}
                                                           checked={{checked: checked, setChecked: setChecked}}
                                                           size={10}
                                                           notUse={{checkbox: true, number: true}}
                                                           onRowClick={handleRowClick}  // 행 클릭 핸들러 전달
                                        />
                                    </div>
                                }


                            </div>


                            <DialogFooter className="sm:justify-start ">
                                <DialogClose asChild>
                                    <Button type="button" variant="outline" onClick={() => setModalOpen(false)}>
                                        닫기
                                    </Button>
                                </DialogClose>
                            </DialogFooter>

                        {/* 재작성 모달 */}
                        {rewriteModalOpen && (
                            <ModalComputerRoomWrite
                                Listener={() => {
                                    getList();
                                    setRewriteModalOpen(false);
                                    setRewriteData(null);
                                }}
                                initialData={rewriteData}
                                triggerButton={null}
                                isOpen={rewriteModalOpen}
                                onClose={() => {
                                    setRewriteModalOpen(false);
                                    setRewriteData(null);
                                }}
                            />
                        )}
                        </div>
                    </>
                    }


                </Dialog>
                )
            }
